"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBox = exports.classes = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var Box_1 = __importDefault(require("@mui/material/Box"));
var styles_1 = require("@mui/material/styles");
var jwt_decode_1 = require("jwt-decode");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var react_router_1 = require("react-router");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var constants_1 = require("containers/App/constants");
var Text_1 = __importDefault(require("shared/components/Text"));
var logging_1 = require("utils/logging");
var single_1 = require("utils/selectors/single");
var PREFIX = 'ImpersonatingBanner';
exports.classes = {
    bannerWrapper: "".concat(PREFIX, "-bannerWrapper"),
    sessionBtn: "".concat(PREFIX, "-sessionBtn"),
};
exports.StyledBox = (0, styles_1.styled)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(exports.classes.bannerWrapper)] = {
            backgroundColor: theme.palette.secondary.light,
            padding: theme.spacing(1, 0, 1, 4),
        },
        _b[".".concat(exports.classes.sessionBtn)] = {
            margin: theme.spacing(0, 3),
            padding: theme.spacing(0, 2),
            height: theme.spacing(4),
        },
        _b);
});
var ImpersonatingBanner = function (_a) {
    var setIsImpersonating = _a.setIsImpersonating;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var _b = __read((0, react_1.useState)(false), 2), endingSession = _b[0], setEndingSession = _b[1];
    var firebaseInstance = (0, react_redux_firebase_1.useFirebase)();
    var history = (0, react_router_1.useHistory)();
    react_1.default.useEffect(function () {
        var adminToken = localStorage.getItem('adminToken');
        if (adminToken && (0, jwt_decode_1.jwtDecode)(adminToken).uid === profile.id) {
            (0, logging_1.logInfo)('Not really impersonating');
            setIsImpersonating(false);
            localStorage.removeItem('adminToken');
        }
    }, []);
    var handleClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var adminToken, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setEndingSession(true);
                    adminToken = localStorage.getItem('adminToken') || '';
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 5]);
                    return [4 /*yield*/, firebaseInstance.auth().signInWithCustomToken(adminToken)];
                case 2:
                    _a.sent();
                    localStorage.removeItem('adminToken');
                    history.push('/admin/customer-management');
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    (0, logging_1.logError)(e_1);
                    return [4 /*yield*/, firebaseInstance.auth().signOut()];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 5:
                    setIsImpersonating(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)(exports.StyledBox, __assign({ display: "flex", justifyContent: "center", alignItems: "center", className: exports.classes.bannerWrapper, position: "fixed", top: 8, left: 600, borderRadius: 4, border: "solid 2px #FFABC5" }, { children: [(0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: ["Currently Impersonating User ", (0, end2end_1.getDisplayName)(profile)] })), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: handleClick, sx: { ml: 3, mr: 1.25, borderRadius: 16 } }, { children: endingSession ? 'Ending Session...' : 'End Session' }))] })));
};
exports.default = (0, react_redux_1.connect)(null, { setIsImpersonating: function (isImpersonating) { return ({ type: constants_1.SET_IMPERSONATING, isImpersonating: isImpersonating }); } })(ImpersonatingBanner);
